<script setup lang="ts">
import { FeeTarget } from '@lib/shared';

import type { PlatformSaleItemEntity, PlatformSaleListingItemEntity } from '~/types/sale.type';

// PROPS
interface Props {
    sale: PlatformSaleItemEntity | PlatformSaleListingItemEntity;
}
const { sale } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
const { companyScopeIds } = useAuthUtils();

// DATA
const feeTarget = computed((): FeeTarget => (isSellerOfSale(sale, companyScopeIds.value) ? FeeTarget.Seller : FeeTarget.Buyer));
</script>

<template>
    <p class="inline-flex gap-1 text-sm">
        <span class="text-dimmed">{{ tt(`fees.simpleNotice.${feeTarget}`) }}</span>
        <SaleFeesInfoModalButton :sale="sale" />
    </p>
</template>
